module.exports = __webpack_public_path__ + "img/04.d61802f1.png";